import { render } from "./BrandSideMenu.vue?vue&type=template&id=58064cf7"
import script from "./BrandSideMenu.vue?vue&type=script&lang=js"
export * from "./BrandSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__